module.exports = __webpack_public_path__ + "img/GppGoodOutlined.657b187c.svg";